import React from 'react';
import { useFormState } from '@fiverr-private/forms';
import { Button } from '@fiverr-private/button';
import { button } from './FormSubmitButton.styles.ve.css';

interface Props {
    loading: boolean;
    children: React.ReactNode;
}

export const FormSubmitButton = ({ loading, children }: Props) => {
    const { isValidating, isValid } = useFormState();

    return (
        <Button className={button} disabled={!isValid} loading={isValidating || loading} type="submit">
            {children}
        </Button>
    );
};
